import React from 'react'
import { SidePanel, type PagingSidePanelType } from '@node-space/ui-components'
import {
  PaymentLimitSidePanelBody,
  PaymentLimitSidePanelHeader,
} from 'components/PaymentLimits/PaymentLimitSidePanelContent'
import type { Limit } from 'types/paymentLimits'
import { highlightRowBasedOnId } from 'utils/table/table'

interface CustomerPaymentLimitSidePanelProps {
  isOpen: boolean
  limit: Limit | null
  paging: PagingSidePanelType
  onClose: () => void
}

export const CustomerPaymentLimitSidePanel = ({
  isOpen,
  limit,
  paging,
  onClose,
}: CustomerPaymentLimitSidePanelProps) => {
  return (
    <SidePanel
      id="customer-payment-limit-side-panel"
      isOpen={isOpen}
      onClose={onClose}
      paging={paging}
      activeRowId={limit?.ruleId}
      onActiveRowChange={highlightRowBasedOnId}
      header={<PaymentLimitSidePanelHeader limit={limit} />}
      body={
        <PaymentLimitSidePanelBody
          limit={limit}
          titleKeys={{
            currency: 'customers.paymentLimitsSidePanel.currency',
            paymentMethod: 'customers.paymentLimitsSidePanel.paymentMethod',
            limitType: 'customers.paymentLimitsSidePanel.limitType',
          }}
        />
      }
    />
  )
}
